import React, { useContext } from "react";
import { CarCompetitionData } from "../contextProvider";
import EndsBadge from "./EndsBadge";
import LastChance from "./LastChance";
import UKsNo1 from "./UKsNo1";
import WinnersSlider from "./WinnersSlider";
import EnterNowButton from "../EnterNowButton";
import { useIsMobile } from "@/app/redux/features/device/selectors";

const Hero = () => {
  const { heroImage, isPrizeAvailable } = useContext(CarCompetitionData);
  const isMobile = useIsMobile();

  if (!heroImage) {
    return <div className="w-full min-h-[360px] aspect-[1/1] bg-[#f1f1f1] lg:h-[calc(100vh-60px)] lg:min-h-[720px]" />;
  }

  return (
    <div className="relative w-full lg:min-h-[max(820px,calc(100vh-60px))] lg:overflow-hidden">
      <div className="relative w-full aspect-[1/1] lg:absolute lg:inset-0 lg:aspect-auto lg:size-full overflow-hidden">
        <img src={heroImage} alt="Featured luxury car" className="size-full object-cover" width={1920} height={1020} />
        {/* Desktop: Figma Main Image overlay — #000000 at 60% */}
        <div className="hidden lg:block absolute inset-0 bg-black/60 pointer-events-none" aria-hidden />
        <EndsBadge className="top-6 right-6 z-[1]" size="hero" />
      </div>

      {isMobile ? (
        <div className="relative z-[1] -mt-24 mx-4 flex flex-col items-center gap-2 bg-white border border-black/8 rounded-2xl shadow-[0_4px_8.5px_rgba(0,0,0,0.25)] px-3 pt-6 pb-4">
          <UKsNo1 />
          <LastChance />
        </div>
      ) : (
        <div className="absolute inset-0 z-[1] flex flex-col items-center justify-center gap-10 px-8">
          <div className="flex flex-col items-center gap-4 max-w-[1223px]">
            <UKsNo1 />
            <LastChance variant="hero" />
          </div>
          <div className="flex flex-col items-center gap-5 w-full max-w-[428px]">
            <WinnersSlider />
            {isPrizeAvailable ? (
              <EnterNowButton text="ENTER NOW »" variation="banner_desktop_btn" place="car_new_main_cta" />
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
